/** @type {import('tailwindcss').Config} */

export default {
  content: ["./src/**/*.{js,jsx,ts,tsx}", "./public/index.html"],
  theme: {
    extend: {
      colors: {
        primary: {
          DEFAULT: "#1D1D1F",
          dark: "#F5F5F7",
        },
        secondary: {
          DEFAULT: "#F57E0C",
          dark: "#F57E0C",
          hover: "#FF8F1F",
        },
        background: {
          default: "#FBFBFD",
          paper: "#FFFFFF",
          panel: "#F5F5F7",
          dark: "#0F0F0F", // Apollo-style: Very dark background
          paperDark: "#1A1A1A", // Apollo-style: Card/paper background
          panelDark: "#141414", // Apollo-style: Sidebar/panel background
        },
        gray: {
          DEFAULT: "#6E6E73",
        },
        text: {
          primary: "#1D1D1F",
          secondary: "#6E6E73",
          primaryDark: "#FFFFFF", // Apollo-style: Pure white for primary text
          secondaryDark: "#8B8B8B", // Apollo-style: Medium gray for secondary text
        },
        divider: {
          DEFAULT: "#D2D2D7",
          dark: "#2A2A2A", // Apollo-style: Subtle but visible dividers
        },
        green: {
          light: "#E4F4E4",
          dark: "#23A73F",
        },
        yellow: {
          DEFAULT: "#FFB500",
        },
        red: {
          light: "#FEE7E7",
          dark: "#FF3B30",
        },
        blue: {
          DEFAULT: "#0066CC",
          dark: "#0077ED",
        },
        avatar: {
          0: "#FF5733",
          1: "#FF6F41",
          2: "#FF8E57",
          3: "#FFA473",
          4: "#FFC299",
          5: "#FFD1A8",
          6: "#F4B942",
          7: "#E67A4A",
          8: "#D96D3F",
          9: "#C8553D",
        },
      },
      fontFamily: {
        sans: [
          "-apple-system",
          "SF Pro Text",
          "Roboto",
          "system-ui",
          "sans-serif",
        ],
      },
      fontSize: {
        h4: ["1.75rem", { lineHeight: "2rem", fontWeight: "600" }],
        subtitle1: ["1.05rem", { lineHeight: "1.5rem", fontWeight: "400" }],
        body1: ["1rem", { lineHeight: "1.5rem", fontWeight: "400" }],
        button: ["0.9rem", { lineHeight: "1.25rem", fontWeight: "500" }],
      },
      borderRadius: {
        input: "12px",
        button: "12px",
        card: "16px",
      },
      boxShadow: {
        subtle: "0 2px 12px rgba(0, 0, 0, 0.08)",
        glow: "0 0 20px rgba(0, 0, 0, 0.1)",
      },
      backdropBlur: {
        apple: "20px",
      },
      height: {
        input: "45px",
      },
      keyframes: {
        "bounce-gentle": {
          "0%, 100%": { transform: "translateY(0)" },
          "50%": { transform: "translateY(-2px)" },
        },
        "gentle-bounce": {
          "0%, 100%": { transform: "translateY(0)" },
          "50%": { transform: "translateY(-2px)" },
        },
        "subtle-wiggle": {
          "0%, 100%": { transform: "rotate(0deg)" },
          "25%": { transform: "rotate(-3deg)" },
          "75%": { transform: "rotate(3deg)" },
        },
        "ping-slow": {
          "75%, 100%": {
            transform: "scale(1.5)",
            opacity: "0",
          },
        },
        "gentle-pulse": {
          "0%, 100%": { transform: "scale(1)" },
          "50%": { transform: "scale(1.03)" },
        },
        "ping-gentle": {
          "0%": { transform: "scale(0.92)", opacity: "0.7" },
          "75%, 100%": { transform: "scale(1.08)", opacity: "0" },
        },
        "pulse-subtle": {
          "0%, 100%": { opacity: 1 },
          "50%": { opacity: 0.5 },
        },
        fadeIn: {
          "0%": { opacity: 0, transform: "translateY(-4px) scale(0.95)" },
          "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
        },
        float: {
          "0%, 100%": { transform: "translateY(0px)" },
          "50%": { transform: "translateY(-3px)" },
        },
        glow: {
          "0%, 100%": { opacity: 0.4, filter: "blur(8px)" },
          "50%": { opacity: 0.7, filter: "blur(12px)" },
        },
      },
      animation: {
        "bounce-gentle": "bounce-gentle 2s ease-in-out infinite",
        "gentle-bounce": "gentle-bounce 3s ease-in-out infinite",
        "subtle-wiggle": "subtle-wiggle 3s ease-in-out infinite",
        "ping-slow": "ping-slow 2s cubic-bezier(0, 0, 0.2, 1) infinite",
        "gentle-pulse": "gentle-pulse 1.2s ease-in-out infinite",
        "ping-gentle": "ping-gentle 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        "pulse-subtle": "pulse-subtle 3s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        fadeIn: "fadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards",
        float: "float 4s ease-in-out infinite",
        glow: "glow 3s ease-in-out infinite",
      },
    },
  },
  darkMode: "class",
  plugins: [],
};
